export const useStyles = () => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      padding: '24px',
      textAlign: 'center',
      '@media (max-width: 1023px)': {
        padding: '20px',
      },
      '@media (max-width: 767px)': {
        padding: '16px',
      },
      '@media (max-width: 480px)': {
        padding: '12px',
      },
    },
    closeButtonContainer: {
      position: 'absolute',
      top: '16px',
      right: '24px',
      zIndex: 1,
    },
    closeButton: {
      color: 'white',
      minWidth: 'auto',
      width: '32px',
      height: '32px',
      p: 0,
      borderRadius: '50%',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    closeButtonText: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      maxWidth: '600px',
      '@media (max-width: 1023px)': {
        gap: '20px',
        maxWidth: '500px',
      },
      '@media (max-width: 767px)': {
        gap: '16px',
        maxWidth: '400px',
      },
      '@media (max-width: 480px)': {
        gap: '12px',
        maxWidth: '280px',
      },
    },
    title: {
      color: '#FFF',
      textAlign: 'center',
      fontFamily: 'Primary-Bold',
      fontSize: '48px',
      fontStyle: 'normal',
      lineHeight: '100%',
      '@media (max-width: 768px)': {
        fontSize: '36px',
      },
      '@media (max-width: 480px)': {
        fontSize: '28px',
      },
    },
    message: {
      color: '#FFF',
      textAlign: 'center',
      fontFamily: 'Noto Sans',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '160%',
      maxWidth: '500px',
      '@media (max-width: 768px)': {
        fontSize: '16px',
      },
      '@media (max-width: 480px)': {
        fontSize: '14px',
      },
    },
  };
}; 